@if (toastData?.content) {
  <p>{{ toastData.content }}</p>
}
<span (click)="hideToast()">x</span>
